/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For information only — not medical advice. Consult a healthcare professional for guidance about your health.`)
};

const es_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo para información — no es asesoramiento médico. Consulta a un profesional sanitario para obtener orientación sobre tu salud.`)
};

const de_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur zu Informationszwecken — keine medizinische Beratung. Konsultieren Sie einen Gesundheitsdienstleister für Anleitung zu Ihrer Gesundheit.`)
};

const nl_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen voor informatiedoeleinden — geen medisch advies. Raadpleeg een gezondheidswerker voor begeleiding over uw gezondheid.`)
};

const fr_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À titre informatif uniquement — pas un conseil médical. Consultez un professionnel de la santé pour des conseils concernant votre santé.`)
};

const it_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo a titolo informativo — non è un consiglio medico. Consulta un professionista sanitario per una guida sulla tua salute.`)
};

const pt_br2_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas para informação — não é aconselhamento médico. Consulte um profissional de saúde para orientação sobre sua saúde.`)
};

const pt_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas para informação — não é aconselhamento médico. Consulte um profissional de saúde para orientação sobre a sua saúde.`)
};

const ja_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`情報提供のみ—医学的なアドバイスではありません。健康に関するガイダンスについては、医療専門家に相談してください。`)
};

const zh_bmi_disclaimer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅供参考，不构成医疗建议。如需了解您的健康状况，请咨询专业医疗人员。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_disclaimer = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_disclaimer(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_disclaimer", locale)
	if (locale === "en") return en_bmi_disclaimer(inputs)
	if (locale === "es") return es_bmi_disclaimer(inputs)
	if (locale === "de") return de_bmi_disclaimer(inputs)
	if (locale === "nl") return nl_bmi_disclaimer(inputs)
	if (locale === "fr") return fr_bmi_disclaimer(inputs)
	if (locale === "it") return it_bmi_disclaimer(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_disclaimer(inputs)
	if (locale === "pt") return pt_bmi_disclaimer(inputs)
	if (locale === "ja") return ja_bmi_disclaimer(inputs)
	return zh_bmi_disclaimer(inputs)
};